export default __webpack_public_path__ + "static/51-ac355528868143981726547bc2a1dd98.png";